import React, { useState } from 'react';
import './App.css';
import TaskList from './components/TaskList';
import TaskForm from './components/TaskForm';

function App() {
  // Estat per emmagatzemar la llista de tasques
  const [tasks, setTasks] = useState([
    { id: 1, text: 'Comprar pa', completed: false, dueDate: null },
    { id: 2, text: 'Acabar informe', completed: true, dueDate: new Date().toISOString() },
  ]);
  
  const handleAddTask = (text) => {
    const task = {
      id: Date.now(), // ID únic basat en el timestamp
      text: text,
      completed: false,
      dueDate: null, // Nou camp
    };
 
    setTasks([...tasks, task]); // Afegim la nova tasca a l'array existent
  };

  const handleToggleComplete = (taskId) => {
    setTasks(
      tasks.map((task) =>
        task.id === taskId ? { ...task, completed: !task.completed } : task
      )
    );
  };

  // NOVA FUNCIÓ per actualitzar només la data
  const handleUpdateTaskDate = (taskId, newDate) => {
    setTasks(
      tasks.map((task) =>
        task.id === taskId ? { ...task, dueDate: newDate ? newDate.toISOString() : null } : task
      )
    );
  };
 
  const handleDeleteTask = (taskId) => {
    setTasks(tasks.filter((task) => task.id !== taskId));
  };

  return (
    <div className="app-container">
      <div className="todo-container">
        <h1>La Meva Llista de Tasques</h1>
        <TaskForm onAddTask={handleAddTask} />
        <TaskList
          tasks={tasks}
          onToggleComplete={handleToggleComplete}
          onDeleteTask={handleDeleteTask}
          onUpdateTaskDate={handleUpdateTaskDate} // Nova prop
        />
      </div>
    </div>
  );
}

export default App;

